import { render, staticRenderFns } from "./HeaderHelp.vue?vue&type=template&id=5a9837b8&scoped=true&"
import script from "./HeaderHelp.vue?vue&type=script&lang=js&"
export * from "./HeaderHelp.vue?vue&type=script&lang=js&"
import style0 from "./HeaderHelp.vue?vue&type=style&index=0&id=5a9837b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9837b8",
  null
  
)

export default component.exports